import React from "react";
import { FormattedMessage } from "react-intl";
import SharedText from "../../../shared/SharedText/SharedText";
import "./statistics.scss";

const performanceData = [
  {
    month: <FormattedMessage id="performance1-month" defaultMessage="Mon" />,
    height: 80,
    opacity: 1,
  },

  {
    month: <FormattedMessage id="performance2-month" defaultMessage="Tue" />,
    height: 30,
    opacity: 0.5,
  },

  {
    month: <FormattedMessage id="performance3-month" defaultMessage="Wed" />,
    height: 60,
    opacity: 1,
  },

  {
    month: <FormattedMessage id="performance4-month" defaultMessage="Thur" />,
    height: 90,
    opacity: 1,
  },

  {
    month: <FormattedMessage id="performance5-month" defaultMessage="Fri" />,
    height: 70,
    opacity: 1,
  },

  {
    month: <FormattedMessage id="performance6-month" defaultMessage="Sat" />,
    height: 20,
    opacity: 0.5,
  },

  {
    month: <FormattedMessage id="performance7-month" defaultMessage="Sun" />,
    height: 30,
    opacity: 0.5,
  },
];

const Statistics = () => {
  return (
    <div className="mobile-statistics">
      <SharedText
        title1={
          <FormattedMessage
            id="mobile-statistics-title"
            defaultMessage="Clear statistics on the go"
          />
        }
        text1={
          <FormattedMessage
            id="mobile-statistics-text1"
            defaultMessage="Call up your account balance with current credit and transactions in the network on the go. Find all statistics by commissions, transactions, cancellation rates, views, clicks, leads and sales and track the daily, weekly and monthly development of sales and activities."
          />
        }
      />

      <div className="right">
        <div className="img" />
        <div className="performance">
          <p className="def-text">
            <FormattedMessage id="performance" defaultMessage="Performance" />
          </p>

          <div className="flex">
            {performanceData.map((props, i) => {
              return (
                <div key={i} className="performanceCard">
                  <div className="line">
                    <div
                      className="inner-line"
                      style={{
                        height: `${props.height}%`,
                        opacity: `${props.opacity}`,
                      }}
                    ></div>
                  </div>

                  <span>{props.month}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
